import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SalColumnWidth = number | string;

type SalColumnsUserConfigItem = {
  isVisible?: boolean;
  order?: number;
  width?: SalColumnWidth;
  align?: "left" | "center" | "right";
};

export type SalColumnsUserConfig = {
  [key: string]: SalColumnsUserConfigItem;
};

type InitialState = {
  columnsUserConfig: SalColumnsUserConfig;
};

type UpdateSalUserConfigItemPayload = {
  columnKey: string;
  configItemKey: keyof SalColumnsUserConfigItem;
  value: any;
};

const getInitialState = (): InitialState => ({
  columnsUserConfig: {},
});

const SalSlice = createSlice({
  name: "sal",
  initialState: getInitialState(),
  reducers: {
    setUserConfig(state, action: PayloadAction<SalColumnsUserConfig>) {
      state.columnsUserConfig = action.payload;
    },
    resetUserConfig(state) {
      state.columnsUserConfig = getInitialState().columnsUserConfig;
    },
    updateUserConfigItem(
      state,
      action: PayloadAction<UpdateSalUserConfigItemPayload>,
    ) {
      const { columnKey, configItemKey, value } = action.payload;
      const columnConfig = state.columnsUserConfig[columnKey] || {};
      state.columnsUserConfig[columnKey] = {
        ...columnConfig,
        [configItemKey]: value,
      };
    },
  },
  extraReducers: () => {},
});

const { reducer } = SalSlice;

export const { setUserConfig, resetUserConfig } =
  SalSlice.actions;

export default reducer;
